"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFileTransfer = exports.getPackageFiles = exports.expandDirectory = exports.updateFileTransferAction = exports.getPackageFilesSuccess = exports.getPackageFilesRequest = exports.expandDirectorySuccess = exports.expandDirectoryRequest = exports.collapseDirectory = void 0;
/* Package Imports */
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
var utils_1 = require("@app/_state/utils");
var PackagesApi = __importStar(require("@app/services/api/packages"));
var utils_2 = require("@server/shared/utils");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.collapseDirectory = createAction('@@packages/COLLAPSE_DIRECTORY', function (resolve) { return function (path) { return resolve(path); }; });
exports.expandDirectoryRequest = createAction('@@packages/EXPAND_DIRECTORY_REQUEST', function (resolve) { return function (path) { return resolve(path); }; });
exports.expandDirectorySuccess = createAction('@@packages/EXPAND_DIRECTORY_SUCCESS', function (resolve) { return function (path, expandDir, files) { return resolve({ path: path, expandDir: expandDir, files: files }); }; });
exports.getPackageFilesRequest = createAction('@@packages/GET_PACKAGE_FILES_REQUEST');
exports.getPackageFilesSuccess = createAction('@@packages/GET_PACKAGE_FILES_SUCCESS', function (resolve) { return function (files) { return resolve(files); }; });
exports.updateFileTransferAction = createAction('@@packages/UPDATE_FILE_TRANSFER', function (resolve) {
    return function (filename, totalSize, transferredBytes, state, transferId, errorCode, errorDesc) {
        return resolve({ filename: filename, totalSize: totalSize, transferredBytes: transferredBytes, state: state, transferId: transferId, errorCode: errorCode, errorDesc: errorDesc });
    };
});
/* Action Creators - end */
/* Packages Files' Action Functions - begin */
var expandDirectory = function (packageId, directory, expandDir) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, descendantFiles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.expandDirectoryRequest(directory.path));
                    if (!!directory.children) return [3 /*break*/, 2];
                    return [4 /*yield*/, PackagesApi.getFiles(packageId, determinePackageFilesType(state), directory.path)];
                case 1:
                    descendantFiles = _a.sent();
                    dispatch(exports.expandDirectorySuccess(directory.path, expandDir, descendantFiles));
                    return [3 /*break*/, 3];
                case 2:
                    dispatch(exports.expandDirectorySuccess(directory.path, expandDir));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.expandDirectory = expandDirectory;
var getPackageFiles = function (packageId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.getPackageFilesRequest());
                    return [4 /*yield*/, PackagesApi.getFiles(packageId, determinePackageFilesType(state))];
                case 1:
                    response = _a.sent();
                    dispatch(exports.getPackageFilesSuccess(utils_1.checkAsperaFileTransfers(state.transfers.asperaTransfers, packageId, response)));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getPackageFiles = getPackageFiles;
var updateFileTransfer = function (filename, packageName, packageCreationDate, totalSize, transferredBytes, packageState, transferId, isFullPackage, errorCode, errorDesc) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, packageDetails;
        return __generator(this, function (_a) {
            state = getState();
            packageDetails = state.packageDetails.packageDetails;
            if (!packageDetails || (!(packageName === packageDetails.title) && !moment_1.default(packageCreationDate).isSame(packageDetails.creationDate))) {
                return [2 /*return*/];
            }
            dispatch(exports.updateFileTransferAction(filename, totalSize, transferredBytes, packageState, ((!isFullPackage) && (transferId)) ? transferId : '', errorCode, errorDesc));
            return [2 /*return*/];
        });
    }); };
};
exports.updateFileTransfer = updateFileTransfer;
/* Packages Files' Action Functions - end */
/* Utility Functions - begin */
var determinePackageFilesType = function (state) {
    var _a, _b;
    // Get Package and User info from the state
    var loggedInUser = state.auth.userInfo;
    var recipients = (_a = state.packageDetails.packageDetails) === null || _a === void 0 ? void 0 : _a.recipients;
    var sender = (_b = state.packageDetails.packageDetails) === null || _b === void 0 ? void 0 : _b.sender;
    // Check if the logged-in user is the sender of the package
    var isSender = (!!loggedInUser && !!sender && sender.userEmail === loggedInUser.userEmail);
    // Check if there's a workgroup/dropbox/shared inbox recipient
    var isWorkgroupPackage = recipients ? recipients === null || recipients === void 0 ? void 0 : recipients.some(function (recipient) { return utils_2.isWorkgroupByEmail(recipient.userEmail); }) : false;
    // Return the specific endpoint needed to get the files from the api
    return (isSender || isWorkgroupPackage) ? 'sent' : 'received';
};
/* Utility Functions - end */ 
